import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
// Side-effect import: i18next must be initialised before the first component renders, or the
// first paint shows raw translation keys.
import './i18n';
import { App } from './App';
import { ThemeModeProvider } from './theme/ThemeModeProvider';
import { msalInstance } from './auth/msalConfig';
import { DEV_AUTH_BYPASS } from './auth/devAuth';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});

async function bootstrap() {
  if (!DEV_AUTH_BYPASS) {
    await msalInstance.initialize();
    const result = await msalInstance.handleRedirectPromise();
    const account = result?.account ?? msalInstance.getAllAccounts()[0];
    if (account) msalInstance.setActiveAccount(account);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <ThemeModeProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ThemeModeProvider>
        </QueryClientProvider>
      </MsalProvider>
    </StrictMode>,
  );
}

void bootstrap();
